import styles from './Documents.section.module.css'
import { Check, Pen, Plus, Trash, X } from 'lucide-react'

import { useState } from 'react'
import { useDocuments, useDocumentsMutations } from '../../../../hooks/documents/useDocuments'
import { useDroppable } from '@dnd-kit/react'
import CardDraggable from '../../components/CardDraggable'
import type { GetDocumentOutput } from '@montatec/contracts'

export default function DocumentsSection() {
  
    const {ref} = useDroppable({
        id: "documents-section"
    })

    const {isLoading, data: documents, isError} = useDocuments()    
    const {createDocument, updateDocument, deleteDocument} = useDocumentsMutations()
    
    const [isAddingdocument, setAddingDocument] = useState(false)
    const [editingDocumentId, setEditingDocumentId] = useState<number | null>(null)


    const [documentInput, setDocumentInput] = useState("")
    const [renewalSelection, setRenewalSelection] = useState(true)
    const [monthInput, setMonthInput] = useState("0")
    const [dayInput, setDayInput] = useState("0")


    const handleCreateDocument = () => {
        if(documentInput.trim() === "") return;
        const days = renewalSelection ? (parseInt(monthInput) * 30 + parseInt(dayInput)) : undefined        

        createDocument.mutate({name: documentInput, isRenewable: renewalSelection, renewalPeriodDays: days})
        handleReset()
    }

    const handleUpdateDocument = () => {        
        if(documentInput.trim() === "") return;
        const days = renewalSelection ? (parseInt(monthInput) * 30 + parseInt(dayInput)) : undefined        
        
        if(!editingDocumentId) return
        
        updateDocument.mutate({id: editingDocumentId, data: {name: documentInput, isRenewable: renewalSelection, renewalPeriodDays: days}})
        handleReset()
    }

    const handleDeleteDocument = (id: number) => {        
        deleteDocument.mutate(id)
    }


    

    const handleSetAddingDocument = () => {
        setAddingDocument(true)
        setEditingDocumentId(null)
    }

    const handleEditDocument = (document: GetDocumentOutput ) => {
        setEditingDocumentId(document.id)
        setDocumentInput(document.name)
        setRenewalSelection(document.isRenewable || false)
        
        const months = document.renewalPeriodDays ? document.renewalPeriodDays / 30 : 0
        const days = document.renewalPeriodDays ? document.renewalPeriodDays % 30 : 0        

        setMonthInput(`${months}`)
        setDayInput(`${days}`)
    }
    
    const handleReset = () => {
        setEditingDocumentId(null)        
        setAddingDocument(false)
        setDocumentInput("")
        setRenewalSelection(true)
        setMonthInput("0")
        setDayInput("0")
    }


    const handleDocumentInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if(e.code === "Enter") {
            if(isAddingdocument) handleCreateDocument()
            if(editingDocumentId) handleUpdateDocument()
        }
    }

    return (           
        <div ref={ref} className={`${styles.documents}`}>
            <div className={styles.nav}>
                <span className={styles.title}>Documentos</span>
                <div className={styles.add}
                    onClick={handleSetAddingDocument}
                >
                    <Plus />
                </div>
            </div>
            <div className={styles.separatorh}></div>
            {
                isAddingdocument && (
                    <div className={styles.itemcreate}>
                        <div className={styles.content}>
                            <div className={styles.name}>
                                <input 
                                    type="text" 
                                    placeholder={"Documento..."}
                                    value={documentInput}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => (setDocumentInput(e.currentTarget.value))}
                                    onKeyDown={handleDocumentInputKeyDown}
                                    autoFocus                                    
                                />
                            </div>
                            <div className={styles.info}>
                                <select value={renewalSelection ? "si" : "no"} onChange={(e) => setRenewalSelection(e.currentTarget.value === "si")}>
                                    <option value="si">Renovable</option> 
                                    <option value="no">No renovable</option>                                     
                                </select>
                                { renewalSelection &&
                                    <div>
                                        <label htmlFor="">
                                            Cada
                                            <input type="number"
                                                value={monthInput} onChange={(e) => setMonthInput(e.currentTarget.value)}
                                            />
                                                meses,
                                        </label>
                                        <label>                                        
                                            <input type="number"
                                                value={dayInput} onChange={(e) => setDayInput(e.currentTarget.value)}
                                            />
                                            días    
                                        </label>                                
                                    </div>
                                }
                            </div>
                        </div>                            
                        <div className={styles.options}>
                            <div className={styles.option}
                                onClick={handleReset}
                            >
                                <X width={16} height={16}/> 
                            </div>
                            <div className={styles.option} 
                                onClick={handleCreateDocument}
                            > 
                                <Check width={16} height={16}/> 
                            </div>
                        </div>
                    </div>
                )
            }
            <div className={styles.list}>
                {isLoading && <span>Cargando...</span>}
                {isError && <span>No se han podido cargar los documentos</span>}                    
                {
                    documents?.map(document => (
                        editingDocumentId !== document.id ? 
                            <CardDraggable 
                                id={document.id}
                                key={`document-${document.id}`} 
                                className={`${styles.item}`}
                            >
                                <div className={styles.content}>
                                    <div className={styles.name}>
                                        <span>{document.name}</span>
                                    </div>
                                    <div className={styles.info}>
                                        <span>{document.isRenewable ? "" : "No"} Renovable</span>
                                        <span>{document.isRenewable && document.renewalPeriodDays ? 
                                            `Cada ${document.renewalPeriodDays > 30 ? 
                                                `${Math.floor(document.renewalPeriodDays / 30)} meses` : `${document.renewalPeriodDays} días`}` : ""}
                                        </span>
                                    </div>
                                </div>                        
                                
                                <div className={styles.options} 
                                    onPointerDown={(e) => e.stopPropagation()}
                                    onPointerUp={(e) => {
                                        e.stopPropagation();                                             
                                    }}
                                    onClick={(e) =>{e.stopPropagation()}}
                                    >
                                    <div className={styles.option}                                        
                                        onClick={(e) =>{e.stopPropagation();  handleEditDocument(document)}}
                                    >
                                        <Pen width={16} height={16}/> 
                                    </div>
                                    <div className={styles.option} 
                                            onClick={() => handleDeleteDocument(document.id)}
                                    > 
                                        <Trash width={16} height={16}/> 
                                    </div>
                                </div>
                            </CardDraggable>
                        :
                            <div className={styles.itemcreate}>
                                <div className={styles.content}>
                                    <div className={styles.name}>
                                        <input 
                                            type="text" 
                                            placeholder={"Documento..."}
                                            value={documentInput}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => (setDocumentInput(e.currentTarget.value))}
                                            onKeyDown={handleDocumentInputKeyDown}
                                            autoFocus                                    
                                        />
                                    </div>
                                    <div className={styles.info}>
                                        <select value={renewalSelection ? "si" : "no"} onChange={(e) => setRenewalSelection(e.currentTarget.value === "si")}>
                                            <option value="si">Renovable</option> 
                                            <option value="no">No renovable</option>                                     
                                        </select>
                                        { renewalSelection &&
                                            <div>
                                                <label htmlFor="">
                                                    Cada
                                                    <input type="number"
                                                        value={monthInput} onChange={(e) => setMonthInput(e.currentTarget.value)}
                                                    />
                                                        meses,
                                                </label>
                                                <label>                                        
                                                    <input type="number"
                                                        value={dayInput} onChange={(e) => setDayInput(e.currentTarget.value)}
                                                    />
                                                    días    
                                                </label>                                
                                            </div>
                                        }
                                    </div>
                                </div>                            
                                <div className={styles.options}>
                                    <div className={styles.option}
                                        onClick={handleReset}
                                    >
                                        <X width={16} height={16}/> 
                                    </div>
                                    <div className={styles.option} 
                                        onClick={handleUpdateDocument}
                                    > 
                                        <Check width={16} height={16}/> 
                                    </div>
                                </div>
                            </div>
                    ))
                }                        
            </div>
        </div>                            
    )
}
